export function max_precision(n, p) {
    return parseFloat(parseFloat(n).toFixed(p));
}

export function hr_by_day(arr) {
    var now = Date.now();
    var first = now/1000-86400*6;
    first = first-first%86400;
    var today = new Date(now).toISOString().split("T")[0];
    
    const days = 7;
    const intervals = Array(days).fill(0).reduce((curr, next, i) => {
      const key = subtractDays(new Date(now), days - i - 1).toISOString().split("T")[0];
      return { ...curr, [key]: 0}
    }, {});
    var rv = { ...intervals};
    var sats = {...intervals};

    now /= 1000;
    for (var i=0; i<arr.length; i++) {
      var pay = arr[i];
      if (pay[2]<first)
        continue;
      var k = new Date(pay[2]*1000).toISOString().split("T")[0];
      var d = pay[3];
      var s = pay[4];
      
      (!rv[k]) ? (rv[k] = d) : (rv[k] += d);
      (!sats[k]) ? (sats[k] = s) : (sats[k] += s);
    }
    for (var e in rv) {
      var dur = 86400;
      if (e == today)
        dur = now % 86400;
      rv[e] = max_precision(rv[e]/dur*2**32/1e12,2);
    }
    return { rv, sats };

    function subtractDays(date, days) {
      date.setDate(date.getDate() - days);
    
      return date;
    }
  }
  

export function add_duration(arr) {
    for (var i=1; i<arr.length; i++) {
        var lt = arr[i-1][2];
        var tt = arr[i][2];
        arr[i].push(tt-lt);
    }
    // no way to calculate duration for first payout, so set averate 10 min.
    if(arr.length) {
      arr[0].push(600);    
    }
}

export function sortByHeightAsc(a, b) {
  const ch = Number(a[1]) - Number(b[1]);
  return (ch < 0) ? -1 : 1;
}

export function sortByHeightDesc(a, b) {
  const ch = Number(b[1]) - Number(a[1]);
  return (ch < 0) ? -1 : 1;
}
